import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { FilterQuery } from "shared";

export type SearchTopologiesDto = ClientInferResponseBody<
  typeof contract.parts.searchTopology,
  200
>;

export const searchTopology = async ({
  id,
  filterParams,
  limit,
  shouldReturnChildrenOfAssembly,
  dimensionWeight,
}: {
  id: string | undefined;
  filterParams: FilterQuery;
  limit?: number;
  shouldReturnChildrenOfAssembly?: boolean;
  dimensionWeight?: number;
}): Promise<SearchTopologiesDto> => {
  if (!id) {
    return [];
  }

  const response = await api.parts.searchTopology.query({
    params: { id },
    query: { ...filterParams, limit, shouldReturnChildrenOfAssembly, dimensionWeight },
    timeout: 30000,
  });

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
